import { render } from "./OrderCreateROI.vue?vue&type=template&id=2b8c1b8e"
import script from "./OrderCreateROI.vue?vue&type=script&lang=js"
export * from "./OrderCreateROI.vue?vue&type=script&lang=js"

import "./OrderCreateROI.vue?vue&type=style&index=0&id=2b8c1b8e&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__